import React from "react";
import "./footer.scss";

const Footer = () => {
  return (
    <div className="footer">
      <div className="fr">&copy;Copyright SUPER-API</div>
      <div className="fr">Made with love by Team SUPER-API.</div>
    </div>
  );
};

export default Footer;
